import axios from 'axios'
import { Message } from 'element-ui'
import postCache from '@/utils/post-cache'
import qs from 'qs'
const messageAttr = 'msg'
const codeAttr = 'code'
const successCode = 200
const defaultTimeout = 30000
const contentType ='application/json'
class Request {
  constructor () {
    this.service = null
  }

  init (interceptors = true, baseURL = '', timeout = defaultTimeout) {
    this.service = axios.create({
      headers: {
        'Content-Type': contentType
      },
      timeout,
      baseURL
    })
    if (interceptors) {
      this.setInterceptor()
    }
  }

  setInterceptor () {
    this.service.interceptors.request.use(req => {
      if(req.url.includes('bigScreenQuoteIndexDay')){
        req.data=qs.stringify(req.data)
        req.headers['Content-Type']='application/x-www-form-urlencoded;charset=UTF-8'
      }
      return req
    })
    this.service.interceptors.response.use(response => {
      const {
        url,
        method,
        ignoreAll = false, // 拒绝公共显示信息
        ignoreSuccess = true // 拒绝成功提示信息
      } = response.config
      if (process.env.VUE_APP_PWA_SWITCH === 'ON' && method === 'post' && response.data[codeAttr] === successCode) {
        postCache.setCache(url, response.data)
      }
      if (!ignoreAll) {
        // switch (response.data[codeAttr]) {
        switch (response.status) {
        case successCode:
          !ignoreSuccess && Message.success(response.data[messageAttr] || '操作成功')
          break
        case -4:
          Message.error(response.data[messageAttr] || '服务异常')
          break
        default:
          Message.error(response.data[messageAttr] || '接口服务器系统异常')
          break
        }
      }
      return {
        ...response.data,
        success: response.data[codeAttr] === successCode
      }
    }, error => {
      const { response, code, config } = error
      
      if (response) {
        switch (response.status) {
        case 404:
          Message.error('404，无效的请求')
          break
        case 500:
          Message.error('500，服务器拒绝')
          break
        case 504:
          Message.error('接口访问超时，请刷新重试')
          break
        default:
          Message.error('接口服务器系统异常')
          break
        }
      } else if (code === 'ECONNABORTED') {
        if (process.env.VUE_APP_PWA_SWITCH === 'ON' && config.method === 'post') {
          return postCache.getCacheByPath(config.url)
        }
      }
      if (process.env.VUE_APP_PWA_SWITCH === 'ON' && !response && !code && config.method === 'post') {
        return {
          success: false,
          ...postCache.getCacheByPath(config.url)
        }
      }
      return {
        success: false
      }
    })
  }

  async post (url, data = {}, config = {}) {
    return await this.service.post(url, data, { ...config }).then((r) => {
      return r
    })
  }

  async get (url, data = {}, config = {}) {
    return await this.service.get(url, {
      params: data,
      ...config
    }).then((r) => {
      return r
    })
  }
}
const baseRequest = new Request()
baseRequest.init()
export default baseRequest
